import universalAddNewUser from './UniversalAddNewUser'
import universalCookieCrumb from './UniversalCookieCrumb'
import universalDataTable from './UniversalDataTable'
import universalEditUser from './UniversalEditUser'
import universalExcelExport from './UniversalExcelExport'
import universalForm from './UniversalForm'
import universalGoogleMap from './UniversalGoogleMap'
import universalLoadingCircle from './UniversalLoadingCircle'
import universalModal from './UniversalModal'
import universalReactSorter from './UniversalReactSorter'
import universalToolBar from './UniversalToolbar'
import UniversalImageDisplayer from './UniversalImageDisplay'

import {
    UniversalAutoComplete,
    UniversalFormSection,
    UniversalTitle,
    UniversalSaveButton,
    UniversalAccordion as universalAccordion,
    UniversalGoogleMapsAc as universalGoogleMapsAc,
} from './UniversalFormStyles'
import universalTagToolbar from './UniversalTagToolbar'
import { UniversalDataGridLayout } from './UniversalLayouts'
import UniversalPdfViewer from './UniversalPdfViewer'
import UniversalTabPanel from './UniversalTabPanel'
import UniversalGrid from './UniversalGrid'
import UniversalGoogleMapsV2 from './components/UniversalGoogleMapsV2'

// UniversalGrid
export const Grid = UniversalGrid

// Form components
export const UniversalAddNewUser = universalAddNewUser
export const UniversalCookieCrumb = universalCookieCrumb
export const UniversalDataTable = universalDataTable
export const UniversalEditUser = universalEditUser
export const UniversalExcelExport = universalExcelExport
export const UniversalForm = universalForm
export const UniversalGoogleMap = universalGoogleMap
export const UniversalGoogleMapsAc = universalGoogleMapsAc
export const UniversalLoadingCircle = universalLoadingCircle
export const UniversalModal = universalModal
export const UniversalReactSorter = universalReactSorter
export const UniversalToolBar = universalToolBar
export const UniversalTagToolbar = universalTagToolbar
export const SaveButton = UniversalSaveButton
export const UniversalAccordion = universalAccordion
export const UniversalGoogleMapV2 = UniversalGoogleMapsV2

//Formatters
export const FormSection = UniversalFormSection
export const Autocomplete = UniversalAutoComplete
export const Title = UniversalTitle

//Layouts
export const DataGridLayout = UniversalDataGridLayout
export const TabPanel = UniversalTabPanel

// Readers
export const PDFViewer = UniversalPdfViewer
export const UniversalImageDisplay = UniversalImageDisplayer
export { UniversalAutoComplete }
